import { pubsub } from '@services';

class ProductPersonalizationField extends HTMLElement {
  #unsubscribers = [];
  #input = null;
  #charCount = null;
  #maxLength = 150;

  connectedCallback() {
    this.form = this.closest('product-form');
    this.#input = this.querySelector('input');
    this.#charCount = this.querySelector('[data-char-count]');

    this.#input.addEventListener('input', () => this.#handleInput());

    this.#unsubscribers.push(pubsub.subscribe('cart:add', () => this.#clear()));
    this.#unsubscribers.push(
      pubsub.subscribe('quantity:change', () => this.#handleQuantityChange())
    );
  }

  disconnectedCallback() {
    this.#unsubscribers.forEach((u) => u());
  }

  #handleInput() {
    const value = this.#input.value;
    const count = value.length;

    this.#charCount.textContent = `${count}/${this.#maxLength}`;

    if (count > 0) {
      this.form.personalizedProduct = {
        id: parseInt(this.dataset.productId),
        quantity: parseInt(this.form.querySelector('quantity-input input')?.value) || 1,
        parent_id: parseInt(this.form.querySelector('input[name="variant-id"]').value),
        properties: { message: value },
      };
    } else {
      this.form.personalizedProduct = null;
    }

    this.#handleProductAttribute(value);
  }

  #handleQuantityChange() {
    if (!this.form.personalizedProduct) return;
    this.form.personalizedProduct = {
      ...this.form.personalizedProduct,
      quantity: parseInt(this.form.querySelector('quantity-input input')?.value) || 1,
    };
  }

  #clear() {
    this.#input.value = '';
    this.#charCount.textContent = `0/${this.#maxLength}`;
    this.form.personalizedProduct = null;
    this.#handleProductAttribute();
  }

  #handleProductAttribute(value) {
    if (!value) return;
    const existing = this.form.querySelector('input[name="properties[_message]"]');
    if (existing) {
      existing.value = value;
    } else {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'properties[_message]';
      input.value = value;
      this.form.querySelector('form').appendChild(input);
    }
  }
}

if (!customElements.get('product-personalization-field')) {
  customElements.define('product-personalization-field', ProductPersonalizationField);
}

export { ProductPersonalizationField };
